import { useDispatch, useSelector } from "react-redux";
import { selectRegistrationForm } from "../redux/selectors/doctorsSelectors";
import { setField } from "../redux/slices/doctorsSlice";
import { validateField } from "../functions/validateForm";
import { useState } from "react";

export const useRegisterForm = () => {
  const dispatch = useDispatch();
  const form = useSelector(selectRegistrationForm); // fallback if undefined

  const [errors, setErrors] = useState({
    fullName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    specialty: "",
    experience: "",
    practicePlace: "",
    country: "",
    city: "",
    clinicAddress: "",
    licenceImg: "",
    identityImg: "",
  });

  const handleChange = (field, value) => {
    if (field === "experience") value = value.replace(/\D/g, "");
    
    // Trim whitespace from password fields to prevent false mismatches
    if (field === "password" || field === "confirmPassword") {
      value = value.trim();
    }

    // update local copy of form
    const updatedForm = { ...form, [field]: value };
    dispatch(setField({ key: field, value }));

    // Validate current field
    let error = validateField(field, value, updatedForm);

    // Special handling: if password or confirmPassword changes, update both errors
    const updatedErrors = { ...errors, [field]: error };

    if (field === "password" || field === "confirmPassword") {
      const password = updatedForm.password || "";
      const confirmPassword = updatedForm.confirmPassword || "";
      updatedErrors.confirmPassword =
        confirmPassword && confirmPassword !== password
          ? "Passwords do not match"
          : "";
    }

    setErrors(updatedErrors);

    // 🔍 Debug logs - Enhanced to detect whitespace issues
    
    // Extra debugging for password fields
    if (field === "password" || field === "confirmPassword") {
    }
  };

  const isFormValid =
    Object.values(form).every((v) => v !== "" && v !== null) &&
    Object.values(errors).every((e) => e === "");

  return { form, errors, handleChange, isFormValid };
};